import { combineReducers } from 'redux';
import { abTestInitialState, abTestReducer } from './abTestReducer';
import { adminInitialState, adminReducer } from './adminReducer';
import { campaignInitialState, campaignReducer } from './campaignReducer';
import { cartInitialState, cartReducer } from './cartReducer';
import { categoriesInitialState, categoriesReducer } from './categoriesReducer';
import { customizeInitialState, customizeReducer } from './customizeReducer';
import { invoicesInitialState, invoicesReducer } from './invoicesReducer';
import { optimizelyInitialState, optimizelyReducer } from './optimizelyReducer';
import { productsInitialState, productsReducer } from './productsReducer';
import { searchInitialState, searchReducer } from './searchReducer';
import { sortInitialState, sortReducer } from './sortReducer';
import { userInitialState, userReducer } from './userReducer';
import { viewInitialState, viewReducer } from './viewReducer';

export const initialState = {
  campaignState: campaignInitialState,
  categoriesState: categoriesInitialState,
  viewState: viewInitialState,
  productsState: productsInitialState,
  cartState: cartInitialState,
  userState: userInitialState,
  sortState: sortInitialState,
  searchState: searchInitialState,
  customizeState: customizeInitialState,
  adminState: adminInitialState,
  abTestState: abTestInitialState,
  invoicesState: invoicesInitialState,
  optimizelyState: optimizelyInitialState,
};

type State = typeof initialState;

const reducers = {
  campaignState: campaignReducer,
  categoriesState: categoriesReducer,
  cartState: cartReducer,
  productsState: productsReducer,
  sortState: sortReducer,
  searchState: searchReducer,
  userState: userReducer,
  viewState: viewReducer,
  customizeState: customizeReducer,
  adminState: adminReducer,
  abTestState: abTestReducer,
  invoicesState: invoicesReducer,
  optimizelyState: optimizelyReducer,
};

export default combineReducers(reducers);
export type { State };
